import { getContrastText } from '../issue/IssueListView';
import { resolveIssueTypeConfig } from '../../constants/issueTypeConfig';
import Avatar from '../common/Avatar';
import { useProfileModal } from '../common/ProfileModalProvider';
import type { ProfileColorKey } from '@maios/shared';

interface MentionCardProps {
  issueKey: string;
  title: string;
  statusName: string;
  statusColor: string;
  issueType: string;
  // CHG-133 Step 7 follow-up
  assignee: {
    userId: string;
    name: string;
    profileImage: string | null;
    displayColor?: string | null;
    nickname?: string | null;
    firstName?: string | null;
    lastName?: string | null;
  } | null;
  compact?: boolean;
  onClick?: () => void;
}

export default function MentionCard({
  issueKey,
  title,
  statusName,
  statusColor,
  issueType,
  assignee,
  compact = false,
  onClick,
}: MentionCardProps) {
  const { openProfileModal } = useProfileModal();
  const typeConfig = resolveIssueTypeConfig(undefined, issueType);

  return (
    <div
      className={`
        border border-gray-200 rounded-lg bg-gray-50
        hover:bg-gray-100 cursor-pointer transition-colors
        my-1 max-w-full
        ${compact ? 'px-2 py-1.5' : 'px-3 py-2'}
      `}
      onClick={(e) => {
        e.stopPropagation();
        onClick?.();
      }}
    >
      {/* 1행: 이슈타입 아이콘 + 이슈키 + 상태 뱃지 */}
      <div className="flex items-center justify-between gap-2">
        <div className="flex items-center gap-1.5 min-w-0">
          <typeConfig.Icon size={compact ? 14 : 16} className={`shrink-0 ${typeConfig.color}`} style={typeConfig.hexColor ? { color: typeConfig.hexColor } : undefined} />
          <span className="font-mono text-sm text-blue-600 shrink-0">{issueKey}</span>
        </div>
        <span
          className="text-[11px] px-1.5 py-0.5 rounded-full font-medium whitespace-nowrap"
          style={{
            backgroundColor: statusColor + '22',
            color: getContrastText(statusColor) === '#FFFFFF' ? statusColor : getContrastText(statusColor),
          }}
        >
          {statusName}
        </span>
      </div>

      {/* 2행: 제목 */}
      <p className={`text-gray-900 truncate mt-0.5 ${compact ? 'text-sm' : 'text-sm'}`}>{title}</p>

      {/* 3행: 담당자 (compact 모드에서는 숨김) */}
      {!compact && (
        <div className="flex items-center gap-1.5 mt-1">
          {assignee ? (
            <>
              <span onClick={(e) => e.stopPropagation()}>
                <Avatar
                  size="xs"
                  userId={assignee.userId}
                  name={assignee.name}
                  avatarUrl={assignee.profileImage}
                  displayColor={assignee.displayColor as ProfileColorKey | null | undefined}
                  firstName={assignee.firstName}
                  onClick={() => openProfileModal(assignee.userId)}
                />
              </span>
              <span className="text-sm text-gray-500">{assignee.name}</span>
            </>
          ) : (
            <span className="text-sm text-gray-400">미배정</span>
          )}
        </div>
      )}
    </div>
  );
}
